/* React hooks */
import {useEffect, useState} from "react";
/* Routing */
import {useNavigate, useParams} from "react-router-dom";
/* Components */
import useData from "../../../../hooks/useData";
import FormCms from "../../../../forms/admin/cms/FormCms";
import Header from "../../../../components/common/Header";
import {getCmsStepInfos} from "../../../../api/admin/cmsReq";
import useAuth from "../../../../hooks/useAuth";
import TiptapView from "../../../../components/common/input-layout/tiptap/TiptapView";
import Icon from "../../../../components/common/Icon";


export default function ViewCmsSteps() {
    const {id} = useParams();
    const { auth } = useAuth();
    const token = auth?.token;
    const { cmsStepInfos, setCmsStepInfos } = useData();
    const oefUrl = process.env.REACT_APP_OEF_URL;
    const imageFolder = process.env.REACT_APP_LOCAL_ASSETS_BASE_URL;
    const [ showModal, setShowModal ] = useState(false);
    const [ forceHideModal, setForceHideModal ] = useState(false);
    const navigate = useNavigate();

    const apiCmsStepInfos = async () => {
        const response = await getCmsStepInfos(token, id);
        setCmsStepInfos(response);
    }

    useEffect(() => {
        apiCmsStepInfos();
    }, [ id ])

    const handleModal = () => {
        setShowModal(true)
    }

    const handleRemoveCmsModal = (e) => {
        if (e.target.classList.contains("cms-infos")) {
            if (id == 0) {
                setForceHideModal(true)
                setShowModal(false)
                navigate(-1)
            }
            setShowModal(false)
        }
    };

    return (
        <main>
            <Header parent="Démarches"
                    location={ (id != 0)
                        ? "Modification de la démarche "
                        : "Ajout d'une démarche" }
                    locationComp ={`${cmsStepInfos?.shortTitle ? cmsStepInfos?.shortTitle : "" }`}
                    slug="/admin/cms/demarches"
            />
            { ((id == 0 && forceHideModal == false) || showModal) &&
                <div className="modal cms-infos">
                    <FormCms apiCmsStep={apiCmsStepInfos} setShowModal={setShowModal}/>
                </div>
            }
            <div className="double-fieldset">
                <fieldset>
                    <Icon source="fa fa-list" span="Contenu de la démarche"/>
                    <div className="form-input html-textarea">
                        <label htmlFor="seoTitle">Titre de l'article</label>
                        <TiptapView content={cmsStepInfos?.title}/>
                    </div>
                    <div className="form-input html-textarea">
                        <label htmlFor="description">Description de l'article</label>
                        <TiptapView content={cmsStepInfos?.description}/>
                    </div>
                    <div className="form-input html-textarea">
                        <label htmlFor="important">Points importants</label>
                        <TiptapView content={cmsStepInfos?.important}/>
                    </div>
                    <div className="form-input html-textarea">
                        <label htmlFor="content">Contenu</label>
                        <TiptapView content={cmsStepInfos?.content}/>
                    </div>
                    <div className="form-input">
                        <label htmlFor="number">Numéro d'article</label>
                        <span id="status">{cmsStepInfos?.number}</span>
                    </div>
                    <div className="form-input">
                        <label htmlFor="category">Catégorie d'article</label>
                        <span id="category">{cmsStepInfos?.categoryName}</span>
                    </div>
                    <div className="form-input">
                        <label htmlFor="status">Statut de publication</label>
                        <span id="status">{cmsStepInfos?.status}</span>
                    </div>
                    <div className="form-input seo-index">
                        <label htmlFor="seoIndex">Index SEO</label>
                        <span>{cmsStepInfos?.seoIndex == 1 ? "Oui" : "Non"}</span>
                    </div>
                    <div className="form-input">
                        <label htmlFor="shortTitle">Short title<br/>Titre affiché dans les menus</label>
                        <textarea name="shortTitle" disabled={true} value={cmsStepInfos?.shortTitle}
                        />
                    </div>
                    <div className="form-input">
                        <label htmlFor="route">Route<br/>URL Affichée dans la barre d'adresse</label>
                        <textarea name="route" disabled={true} value={cmsStepInfos?.route}/>
                    </div>
                    <div className="form-input">
                        <label htmlFor="seoTitle">Titre SEO<br/>Titre de la page pour les moteurs de
                            recherche</label>
                        <textarea name="seoTitle" disabled={true} value={cmsStepInfos?.seoTitle}/>
                    </div>
                    <div className="form-input">
                        <label htmlFor="seoDescription">Meta SEO<br/>Description de la page pour les moteurs de recherche</label>
                        <textarea name="seoDescription" disabled={true} value={cmsStepInfos?.seoDescription}/>
                    </div>
                    <div className="form-input">
                        <label htmlFor="imageName">Illustration de l'étape</label>
                        {(cmsStepInfos?.imageName) ?
                            <img src={`${imageFolder}/img/etapes/${cmsStepInfos?.imageName}`} alt="Illustration de l'étape"/>
                            : <span>Pas d'illustration</span>
                        }
                    </div>
                    <div className="buttons-container">
                        <button className="red-button" onClick={handleModal}><i className="fa fa-pen-to-square"/><span>Modifier les informations</span></button>
                    </div>
                </fieldset>
                <fieldset className="preview">
                    <Icon source="fa fa-eye" span="Aperçu"/>
                    {cmsStepInfos?.route ?
                        <iframe src={`${oefUrl}/etapes-funeraires/${cmsStepInfos?.route}`}
                                title="Aperçu de la démarche" width="100%" height="100%"></iframe>
                        : <span>Pas d'aperçu disponible</span>
                    }
                    <div className="buttons-container back">
                        <button onClick={() => navigate(-1)}><i className="fa fa-arrow-left"/><span>Retour</span></button>
                    </div>
                </fieldset>
            </div>
        </main>
    )
}